import { render } from "./CreateMaterial.vue?vue&type=template&id=05bfd139&scoped=true"
import script from "./CreateMaterial.vue?vue&type=script&lang=js"
export * from "./CreateMaterial.vue?vue&type=script&lang=js"

import "./CreateMaterial.vue?vue&type=style&index=0&id=05bfd139&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05bfd139"]])

export default __exports__